import { useState, useCallback, useEffect } from 'react';
import { VIEW_MODE, VIEW_MODE_STORAGE_KEY } from '../utils/constants';

/** Legge la preferenza salvata, con ripiego sulla vista a card. */
function readStored() {
  try {
    const v = window.localStorage.getItem(VIEW_MODE_STORAGE_KEY);
    if (v === VIEW_MODE.CARDS || v === VIEW_MODE.TABLE) return v;
  } catch {
    // localStorage non disponibile: ripiego silenzioso.
  }
  return VIEW_MODE.CARDS;
}

/**
 * Modalità di visualizzazione (card/tabella) con persistenza locale della
 * preferenza dell'utente.
 */
export function useViewMode() {
  const [viewMode, setViewMode] = useState(readStored);

  useEffect(() => {
    try {
      window.localStorage.setItem(VIEW_MODE_STORAGE_KEY, viewMode);
    } catch {
      // Ignora errori di storage (es. modalità privata).
    }
  }, [viewMode]);

  const set = useCallback((mode) => {
    if (mode === VIEW_MODE.CARDS || mode === VIEW_MODE.TABLE) setViewMode(mode);
  }, []);

  return [viewMode, set];
}
